import { Grid, Tooltip} from "@mui/material";

export function getPmorderStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'You must enter Business Id',
            required:true,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'Title',
            value:'',
            error:false,
            errorMessage:'You must enter Title',
            required:true,
            fieldtype:'string'
        },
        productid:{
            name:'productid',
            label:'productid',
            value:'',
            error:false,
            errorMessage:'You must enter productid',
            required:true,
            fieldtype:'ID'
        },
        orderid:{
            name:'orderid',
            label:'Order Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        pmstatus:{
            name:'pmstatus',
            label:'PM Status',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        orderdate:{
            name:'orderdate',
            label:'Order Date',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        unitid:{
            name:'unitid',
            label:'Unit Id',
            value:'',
            error:false,
            errorMessage:'You must enter Unit Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        unitname:{
            name:'unitname',
            label:'Unit Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        qty:{
            name:'qty',
            label:'qty',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
        receivedon:{
            name:'receivedon',
            label:'Received On',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        receivedqty:{
            name:'receivedqty',
            label:'Received Qty',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
        availableqty:{
            name:'availableqty',
            label:'Available Qty',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
        vendorid:{
            name:'vendorid',
            label:'Vendor Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        vendorname:{
            name:'vendorname',
            label:'Vendor Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        requiredqty:{
            name:'requiredqty',
            label:'Required Qty',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
        orderedqty:{
            name:'orderedqty',
            label:'Ordered Qty',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'Title', width:100 },
        { field: 'productid', headerName: 'productid', width:150 },
        { field: 'orderid', headerName: 'Order Id', width:150 },
        { field: 'pmstatus', headerName: 'PM Status', width:150 },
        { field: 'orderdate', headerName: 'Order Date', width:150 },
        { field: 'unitid', headerName: 'Unit Id', width:150 },
        { field: 'unitname', headerName: 'Unit Name', width:150 },
        { field: 'qty', headerName: 'qty', width:150 },
        { field: 'receivedon', headerName: 'Received On', width:150 },
        { field: 'receivedqty', headerName: 'Received Qty', width:150 },
        { field: 'availableqty', headerName: 'Available Qty', width:150 },
        { field: 'vendorid', headerName: 'Vendor Id', width:150 },
        { field: 'vendorname', headerName: 'Vendor Name', width:150 },
        { field: 'requiredqty', headerName: 'Required Qty', width:150 },
        { field: 'orderedqty', headerName: 'Ordered Qty', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['productid']:{
          ...formValues['productid'],
          value:data.productid,
        },['orderid']:{
          ...formValues['orderid'],
          value:data.orderid,
        },['pmstatus']:{
          ...formValues['pmstatus'],
          value:data.pmstatus,
        },['orderdate']:{
          ...formValues['orderdate'],
          value:data.orderdate,
        },['unitid']:{
          ...formValues['unitid'],
          value:data.unitid,
        },['unitname']:{
          ...formValues['unitname'],
          value:data.unitname,
        },['qty']:{
          ...formValues['qty'],
          value:data.qty,
        },['receivedon']:{
          ...formValues['receivedon'],
          value:data.receivedon,
        },['receivedqty']:{
          ...formValues['receivedqty'],
          value:data.receivedqty,
        },['availableqty']:{
          ...formValues['availableqty'],
          value:data.availableqty,
        },['vendorid']:{
          ...formValues['vendorid'],
          value:data.vendorid,
        },['vendorname']:{
          ...formValues['vendorname'],
          value:data.vendorname,
        },['requiredqty']:{
          ...formValues['requiredqty'],
          value:data.requiredqty,
        },['orderedqty']:{
          ...formValues['orderedqty'],
          value:data.orderedqty,
        },
      })
}